import * as Util from '../../util';
export var getTextosUsuario = function getTextosUsuario(state) {
  return state.textosUsuario;
};
export var getModoCrear = function getModoCrear(state) {
  return getTextosUsuario(state).modoCrear;
};
export var getTextoById = function getTextoById(state, id) {
  return getTextosUsuario(state).textos.find(function (texto) {
    return texto.id === id;
  });
};
export var getTextosPagina = function getTextosPagina(state, libroId, numPagina) {
  return getTextosUsuario(state).textos.filter(function (texto) {
    return texto.libroId === libroId && texto.numPagina === numPagina;
  });
};
export var getTextosZona = function getTextosZona(state, libroId, numPagina, numZona) {
  return getTextosUsuario(state).textos.filter(function (texto) {
    return texto.libroId === libroId && texto.numPagina === numPagina && texto.numZona === numZona;
  });
};
export var getCrearTextoUsuarioActivo = function getCrearTextoUsuarioActivo(state) {
  return getTextosUsuario(state).crearActivo;
};
export var getTextosUsuarioPagina = function getTextosUsuarioPagina(state, libroId, numPagina) {
  var key = Util.getKeyTextosPagina(libroId, numPagina);
  var textosUsuario = getTextosUsuario(state);
  return textosUsuario.textos.filter(function (texto) {
    return texto.id.indexOf(key) !== -1;
  });
};